<div
  role="dialog"
  aria-labelledby="modalAddEditContactTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="modalAddEditContactTitle">
          {{ title }}
        </h5>
        <button
          type="button"
          class="btn-close"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">
                {{ 'kanban.transferCard.funnel' | translate }}
                <span class="text-danger">*</span>
              </label>
              <mat-select
                class="form-control"
                formControlName="funnel"
                [placeholder]="'kanban.transferCard.funnelPlaceholder' | translate"
              >
                <div class="overflow-auto" style="max-height: 220px">
                  @for (item of funnels; track $index) {
                    <mat-option [value]="item._id" (click)="selectFunnel(item)">
                      {{ item.name }}
                    </mat-option>
                  }
                </div>
              </mat-select>
              <field-error-component
                [field]="'funnel'"
                [label]="'kanban.transferCard.funnel' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-3">
              <label class="form-label">
                {{ 'kanban.transferCard.stage' | translate }}
                <span class="text-danger">*</span>
              </label>
              <mat-select
                class="form-control"
                formControlName="stage"
                [placeholder]="'kanban.transferCard.stagePlaceholder' | translate"
              >
                <div class="overflow-auto" style="max-height: 220px">
                  @for (item of filteredStages; track $index) {
                    <mat-option [value]="item._id">
                      <span>{{ item.name }}</span>
                      @if (item.lostDeal) {
                        <span class="ms-2 text-danger">{{ 'kanban.transferCard.lostLabel' | translate }}</span>
                      }
                      @if (item.wonDeal) {
                        <span class="ms-2 text-success">{{ 'kanban.transferCard.wonLabel' | translate }}</span>
                      }
                    </mat-option>
                  }
                </div>
              </mat-select>
              <field-error-component
                [field]="'stage'"
                [label]="'kanban.transferCard.stage' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-outline-light" (click)="close()">
          {{ 'kanban.transferCard.close' | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="confirm()"
          [disabled]="!formGroup.valid || loading"
        >
          {{ confirmLabel }}
        </button>
      </div>
    </div>
  </div>
</div>
